<template>
    <div class="leads-nexus" v-if="isMounted">
        <v-table-nexus
            ref="table"
            :headers="headers"
            :data="data"
            :page="page"
            :order-by="order"
            :total="total"
            :limit="limit"
            :limits="limits"
            :isLoader="isLoader"
            :select="isTableSelect"
            :displays="displays"
            @page="changePage"
            @order="changeOrder"
            @selected="selectedTable"
        >
            <template v-slot:header>
                <div class="p-4">
                    <ul class="flex items-center tabs">
                        <li v-for="(count, index) of counts"
                            :key="index"
                            class="tabs__tab"
                            :class="{
                                'active': selectStatus === count.event,
                                'disabled': count.count <= 0
                            }"
                            @click="changeTab(count.event)"
                        >
                            {{$t(count.name)}} - {{count.count}}
                        </li>
                    </ul>
                </div>

                <div class="p-4 flex items-center">
                    <div class="flex items-center" ref="actions">
                        <v-limit
                            class="mr-2"
                            :limits="limits"
                            :total="total"
                            :limit="limit"
                            :page="page"
                            @limit="changeLimit"
                        />

                        <v-view
                            class="mr-2"
                            :displays="displays"
                            @change="changeView"
                        />

                        <div class="flex items-center" v-can="'statistic_lead.update_status'">
                            <div v-if="selectStatus === 'sended'" class="flex items-center">
                                <vs-button
                                    :disabled="(activeGlobalStatuses && !statusIds.length) || !data.length"
                                    @click="updateGroupStatus"
                                    v-tooltip="$t('tooltip.updateStatus')"
                                    class="mr-2"
                                    radius
                                    type="flat"
                                    v-bind="$iconData(!activeGlobalStatuses ? 'icon-command' : 'icon-save', !activeGlobalStatuses ? 'fi-rs-command' : 'fi-rr-disk')"
                                ></vs-button>

                                <vs-button
                                    v-if="activeGlobalStatuses"
                                    @click="updateGroupStatusClose"
                                    v-tooltip="$t('global.Cancel')"
                                    class="mr-2"
                                    radius
                                    type="flat"
                                    color="danger"
                                    v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                                ></vs-button>
                            </div>
                        </div>

                        <div v-if="selectStatus === 'not_valid' || selectStatus === 'hold'">
                            <vs-button
                                :disabled="(activeGlobalToTrash && !leadTrashIds.length) || !data.length"
                                @click="toTrashGlobal(leadTrashIds)"
                                v-tooltip="$t('tooltip.toTrash')"
                                class="mr-2"
                                radius
                                type="flat"
                                v-can="'statistic_lead.update'"
                                v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                            ></vs-button>
                        </div>
                        <div v-if="activeGlobalToTrash && (selectStatus === 'not_valid' || selectStatus === 'hold')">
                            <vs-button
                                @click="toTrashGlobalClose"
                                v-tooltip="$t('global.Cancel')"
                                class="mr-2"
                                radius
                                type="flat"
                                v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                                color="danger"
                            ></vs-button>
                        </div>
                        <div>
                            <vs-button
                                v-tooltip="$t('tooltip.Refresh_table')"
                                class="mr-2"
                                radius
                                type="flat"
                                v-bind="$iconData('icon-rotate-cw', 'fi-rr-rotate-right')"
                                @click="refreshTable"
                            ></vs-button>
                        </div>

                        <div>
                            <vs-button
                                v-can="'statistic_lead.download_leads'"
                                class="mr-2"
                                v-tooltip="$t('tooltip.Download_CSV')"
                                radius
                                type="flat"
                                v-bind="$iconData('icon-download', 'fi-rr-download')"
                                @click="downloadCSV"
                            ></vs-button>
                        </div>
                    </div>

                    <div class="input__filter">
                        <v-input-chip-filter
                            :offset="inputOffset"
                            :data="inputs"
                        >
                            <vs-button
                                color="primary"
                                type="filled"
                                size="small"
                                v-bind="$iconData('icon-filter', 'fi-rr-filter')"
                                @click="isFilter = !isFilter"
                            ></vs-button>
                        </v-input-chip-filter>
                    </div>
                </div>
            </template>

            <template v-slot:name="item">
                <div class="whitespace-no-wrap flex items-center">
                    <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-user', 'fi-rr-user')"></vs-icon>
                    {{ item.first_name ? item.first_name : '-' }} {{ item.last_name ? item.last_name : '-' }}
                    <vs-icon
                        v-if="isPermission('statistic_lead.comments') && item.status === 'sended'"
                        v-tooltip="$t('tooltip.Comment')"
                        class="cursor-pointer"
                        @click="comments(item)"
                        color="primary"
                        v-bind="$iconData('icon-message-square', 'fi-rr-comment-dots')"
                    />
                    <vs-icon
                        v-if="isPermission('statistic_lead.history_statuses') && item.status === 'sended'"
                        v-tooltip="$t('modals.Lead_history_statuses')"
                        class="cursor-pointer ml-1"
                        @click="getHistoryStatuses(item)"
                        color="primary"
                        v-bind="$iconData('icon-book', 'fi-rr-book')"
                    />
                </div>
            </template>

            <template v-slot:email="item">
                <div class="whitespace-no-wrap flex items-center">
                    <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-mail', 'fi-rr-envelope')"></vs-icon>
                    {{ item.email ? item.email : '-' }}
                </div>
            </template>

            <template v-slot:phone="item">
                <div class="whitespace-no-wrap flex items-center">
                    <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-smartphone', 'fi-rr-mobile-notch')"></vs-icon>
                    {{ item.phone ? item.phone : '-' }}
                </div>
            </template>

            <template v-slot:guarantee="item">
                <div class="text-center">
                    <vs-icon v-if="item.guarantee" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                    <vs-icon v-else color="danger" v-bind="$iconData('icon-x', 'fi-rr-cross-small')"></vs-icon>
                </div>
            </template>

            <template v-slot:autologin="item">
                <div class="text-center">
                    <vs-icon v-if="item.is_autologin" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                    <vs-icon v-else color="danger" v-bind="$iconData('icon-x', 'fi-rr-cross-small')"></vs-icon>
                </div>
            </template>

            <template v-slot:ftd_status="item">
                <div class="text-center">
                    <vs-icon v-if="item.ftd_status_declined" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                    <div v-else>-</div>
                </div>
            </template>

            <template v-slot:country="item">
                <div v-if="item.country && item.country !== undefined && item.country !== 'undefined'"
                     class="flex items-center">
                    <flag width="25" :iso="item.country" type="country"/>
                    <span class="pl-2">{{ item.country }}</span>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:language="item">
                <div v-if="item.language && item.language !== undefined && item.language !== 'undefined'"
                     class="flex items-center">
                    <flag width="25" :iso="item.language" type="language"/>
                    <span class="pl-2">{{ item.language }}</span>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:geo="item">
                <div v-if="item.geo && item.language !== undefined && item.geo !== 'undefined'" class="flex items-center">
                    <img style="width: 25px" :src="getGeoFlag(item.geo).flag" alt="">
                    <span class="pl-2 whitespace-no-wrap">{{ item.geo }}</span>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:advertiser="item">
                <div class="whitespace-no-wrap">{{ item.advertiser || item.advertiser_id || '-' }} /
                    {{ item.integration_name ? item.integration_name : '-' }}
                </div>
            </template>

            <template v-slot:status="item">
                <div class="flex justify-center">
                    <div v-if="!item.status">-</div>
                    <vs-chip v-else transparent :color="statusColor(item.status)">
                        <span class="whitespace-no-wrap">{{ createName(item.status) }}</span>
                    </vs-chip>
                </div>
            </template>

            <template v-slot:team="item">
                <div class="flex items-center whitespace-no-wrap">
                    <vs-icon color="primary" v-bind="$iconData('icon-users', 'fi-rr-users')"></vs-icon>
                    <div class="ml-2 whitespace-no-wrap">{{ item.team_name || item.team_id || '-' }}</div>
                </div>
            </template>

            <template v-slot:affiliate="item">
                <div class="whitespace-no-wrap">{{ item.affiliate_name ? item.affiliate_name : '-' }}</div>
            </template>

            <template v-slot:sms="item">
                <div v-if="!item.sms_error && !item.sms_status && !item.sms_text">-</div>
                <div v-else>
                    <p>{{ item.sms_error }}</p>
                    <p>{{ item.sms_status }}</p>
                    <p>{{ item.sms_text }}</p>
                </div>
            </template>

            <template v-slot:eValidation="item">
                <div v-if="item.errors_validation && Object.keys(item.errors_validation).length">
                    <div class="flex items-center" v-for="(value, key) in item.errors_validation" :key="key">
                        <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                        <div class="whitespace-no-wrap ml-2" v-for="(v, ind) of value" :key="ind">{{ v }}</div>
                    </div>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:a_history="item">
                <div v-if="item.advertisers_history">
                    <div class="flex items-center" v-if="value" v-for="(value, key) in item.advertisers_history"
                         :key="key">
                        <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                        <div class="whitespace-no-wrap ml-2">{{ value }}</div>
                    </div>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:errorStatus="item">
                <div v-if="item.advertiser_response" class="flex items-center">
                    <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                    <div>
                        <div class="whitespace-no-wrap ml-2 textOverflow statusErrorsText">{{ item.advertiser_response }}</div>
                    </div>
                    <vs-icon
                        class="ml-2 cursor-pointer"
                        color="primary"
                        v-tooltip="$t('tooltip.Copy')"
                        @click.stop.prevent="copy(item.advertiser_response)"
                        v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                    />
                    <vs-icon
                        v-if="item.advertiser_response && item.advertiser_response.length >= 35"
                        class="ml-2 cursor-pointer"
                        color="primary"
                        @click.stop.prevent="errorStatusInfo(item.advertiser_response)"
                        v-bind="$iconData('icon-eye', 'fi-rr-eye')"
                    />
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:created_at="item">
                <div v-if="!item.created_at">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="item.created_at">{{ item.created_at|date }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="item.created_at">{{ item.created_at|time }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:send_date="item">
                <div v-if="!item.send_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="item.send_date">{{ item.send_date|date }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="item.send_date">{{ item.send_date|time }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:first_action_date="item">
                <div v-if="!item.first_action_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="item.first_action_date">{{item.first_action_date|date}}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="item.first_action_date">{{item.first_action_date|time}}</span>
                    </div>
                </div>
            </template>

            <template v-slot:landing="item">
                <div class="flex items-center">
                    <v-text v-if="item.domain || item.landing_url" :text="item.domain || item.landing_url">
                        <div class="ml-2 flex items-center" @click="copy(item.landing_url)">
                            <vs-icon
                                class="cursor-pointer block"
                                v-bind="$iconData('icon-link-2', 'fi-rr-link-alt')"
                                :color="(item.domain || item.landing_url) ? 'success' : 'danger'"
                                v-tooltip="$t('tooltip.Copy')"
                            />
                        </div>
                    </v-text>

                  <div v-else>-</div>
                </div>
            </template>

            <template v-slot:actions="item">
                <div class="product-name font-medium truncate flex items-center">
                    <div class="flex" v-if="item.status === 'sended'">
                        <template v-if="isPermission('statistic_lead.synchronization_management')">
                            <vs-button
                                v-if="item.advertiser_lead_id.includes('_sync_paused_')"
                                @click="toggleLeadSynchronization(item.id, true)"
                                :disabled="isLoader"
                                radius
                                color="primary"
                                type="flat"
                                v-bind="$iconData('icon-play', 'fi-rr-play')"
                                v-tooltip="$t('modals.lead_synchronization_enable')"
                            ></vs-button>

                            <vs-button
                                v-else
                                @click="toggleLeadSynchronization(item.id, false)"
                                :disabled="isLoader"
                                radius
                                color="primary"
                                type="flat"
                                v-bind="$iconData('icon-pause', 'fi-rr-pause')"
                                v-tooltip="$t('modals.lead_synchronization_disable')"
                            ></vs-button>
                        </template>
                    </div>

                    <div v-if="item.status === 'hold' || item.status === 'not_valid'">
                        <vs-button
                            @click="toTrash([item.id])"
                            radius
                            color="primary"
                            type="flat"
                            v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                            v-can="'statistic_lead.update'"
                            v-tooltip="$t('tooltip.toTrash')"
                        ></vs-button>
                    </div>
                    <div v-if="item.status === 'hold'">
                        <vs-button
                            radius
                            @click="infoByIntegration(item)"
                            color="primary"
                            type="flat"
                            v-bind="$iconData('icon-info', 'fi-rr-info')"
                            v-can="'statistic_lead.check_lead_integrations'"
                            v-tooltip="$t('modals.Lead_info')"
                        />
                    </div>
                    <div v-if="item.status !== 'sended' && item.status !== 'duplicate'">
                        <vs-button
                            v-can="'statistic_lead.update'"
                            @click="edit(item)"
                            radius
                            color="primary"
                            type="flat"
                            v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"
                            v-tooltip="$t('modals.Edit_lead')"
                        ></vs-button>
                    </div>
                </div>
            </template>
        </v-table-nexus>

        <v-sidebar
            ref="sidebar"
            class="leads-nexus-sidebar"
            width="350px"
            :active="isFilter"
            @close="closeSidebar"
        >
            <template v-slot:header>
                <div class="leads-nexus-sidebar__container">
                    <div>{{ $t('global.Filters') }}</div>

                    <div class="leads-nexus-sidebar__actions">
                        <vs-button
                            class="mr-2"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-rotate-cw', 'fi-rr-rotate-right')"
                            @click="resetFilter"
                        ></vs-button>

                        <vs-button
                            class="mr-2"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                            @click="closeSidebar"
                        ></vs-button>
                    </div>
                </div>
            </template>

            <template v-slot:footer>
                <vs-button
                    class="w-full"
                    color="primary"
                    type="filled"
                    @click="filterClick"
                >{{ $t('buttons.Filter') }}</vs-button>
            </template>

            <ds-filter
                ssr
                ref="filter"
                :is-actions="false"
                :fields="fields"
                :data="filterOptions"
                :select-data="filter"
                @submit="submitFilter"
                @resetFilter="refreshFilter"
            >
                <vs-col
                    vs-w="12"
                    vs-sm="12"
                    vs-lg="12"
                    vs-xs="12"
                >
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="direction" vs-name="send_date" vs-value="send_date">{{ $t('date.send_date') }}</vs-radio>
                    </div>
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="direction" vs-name="created_at" vs-value="created_at">{{ $t('date.created_at') }}</vs-radio>
                    </div>
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="direction" vs-name="first_action_date" vs-value="first_action_date">{{ $t('date.first_action_date') }}</vs-radio>
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="12"
                    vs-lg="12"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t(`date.${direction}`) }}</label>
                        <date-picker
                            @select="selectedDate"
                            :date="date[direction]"
                            :direction="direction"
                        />
                    </div>
                </vs-col>
            </ds-filter>
        </v-sidebar>
    </div>
</template>

<script>
import qs from "qs"
import VTableNexus from "./components/VTableNexus.vue"
import send from "@/utils/fetch"
import ErrorHandler from "@/utils/errorHandler"
import {checkPermission, dateParse} from '@/utils/mixins'
import history from '@/mixins/history'
import {copy, download, getLanguages} from "@/utils/utils"
import EventBus from "@/store/eventBus"
import VLimit from "@/components/VLimit.vue"
import VView from "@/components/VView.vue"
import VFilter from "@/components/VFilter.vue"
import VSidebar from "@/components/Sidebar.vue"
import VInputChipFilter from "@/views/analytics/components/VInputChipFilter.vue"
import VText from '@/components/Text.vue'

export default {
    mixins: [checkPermission, dateParse, history],

    components: {
        VInputChipFilter,
        VSidebar,
        VView,
        VLimit,
        VTableNexus,
        VFilter,
        VText
    },

    data() {
        return {
            isMounted: false,
            isFilter: false,
            activeGlobalToTrash: false,
            activeGlobalStatuses: false,
            leadTrashIds: [],
            statusIds: [],
            data: [],
            counts: [],
            inputOffset: 0,
            page: 1,
            total: 0,
            limit: 100,
            limits: [50, 100, 500],
            isLoader: false,
            selectStatus: 'sended',
            displays: {},
            order: {},
            filter: {},
            filterOptions: {},
            direction: 'send_date',
            date: {
                created_at: {startDate: new Date(), endDate: new Date()},
                send_date: {startDate: new Date(), endDate: new Date()},
                first_action_date: {startDate: new Date(), endDate: new Date()},
            },
            selectDateSystem: {
                start: this.dateParse(new Date()),
                end: this.dateParse(new Date()),
                direction: 'send_date'
            },
            selectDate: {
                start: this.dateParse(new Date()),
                end: this.dateParse(new Date()),
                direction: 'send_date'
            },
            inputs: [],
            fields: [
                {name: 'global.Email', type: 'input', label: 'email', field: 'email', reKey: 'emails', full: true},
                {name: 'modals.Phone', type: 'input', label: 'phone', field: 'phone', reKey: 'phones', full: true},
                {name: 'statistic_fields.id', type: 'input', label: 'id', field: 'id', reKey: 'ids', full: true},
                {name: 'table_filters.manager', type: 'select', label: 'manager_ids', field: 'manager_ids', reKey: 'manager_ids', multiple: true, full: true},
                {name: 'table_filters.advertiser_id', type: 'select', label: 'advertisers', field: 'advertisers', reKey: 'advertiser_ids', multiple: true, full: true},
                {name: 'table_filters.advertiser_integration_id', type: 'select', label: 'integrations', field: 'integrations', reKey: 'advertiser_integration_ids', multiple: true, full: true},
                {name: 'table_filters.traffic_model_id', type: 'select', label: 'traffic_models', field: 'traffic_models', reKey: 'traffic_model_ids', multiple: true, full: true},
                {name: 'table_filters.team_id', type: 'select', label: 'teams', field: 'teams', reKey: 'team_ids', multiple: true, full: true},
                {name: 'table_filters.affiliate_id', type: 'select', label: 'affiliates', field: 'affiliates', reKey: 'affiliate_ids', multiple: true, full: true},
                {name: 'table_filters.group_status', type: 'select', label: 'group_statuses', field: 'group_statuses', multiple: true, full: true},
                {name: 'table_filters.language', type: 'select', label: 'languages', field: 'languages', multiple: true, full: true},
                {name: 'table_filters.country', type: 'select', label: 'countries', field: 'countries', multiple: true, full: true},
                {name: 'table_filters.offer_name', type: 'select', label: 'offer_names', field: 'offer_names', multiple: true, full: true},
                {name: 'table_filters.landing_name', type: 'select', label: 'landing_names', field: 'landing_names', multiple: true, full: true},
                {name: 'table_filters.geo', type: 'select', label: 'geos', field: 'geos', multiple: true, full: true},
                {name: 'table_filters.domain', type: 'select', label: 'domains', field: 'domains', full: true},
                {name: 'table_filters.guarantee', type: 'select', label: 'guarantee', field: 'guarantee', reKey: 'guarantees', can: 'statistic_lead.guarantee', full: true},
                {name: 'table_filters.sub', type: 'input', label: 'sub', field: 'sub', reKey: 'subs', full: true},
            ],
            headers: [],
            headerSystems: [
                {name: 'statistic_fields.id', key: 'id', sortKey: 'id', value: 'id', translate: true},
                {name: 'statistic.guarantee', key: 'guarantee', sortKey: 'guarantee', value: 'guarantee', translate: true, can: 'statistic_lead.guarantee'},
                {name: 'Autologin', key: 'is_autologin', sortKey: 'is_autologin', value: 'autologin', translate: false},
                {name: 'FTD Status', key: 'ftd_status', value: 'ftd_status', can: 'settings_moderation.status'},
                {name: 'global.Name', key: 'name', sortKey: 'first_name', value: 'name', translate: true},
                {name: 'global.Email', key: 'email', sortKey: 'email', value: 'email', translate: true},
                {name: 'table_filters.phone', key: 'phone', sortKey: 'phone', value: 'phone', translate: true},
                {name: 'global.Country', key: 'country', sortKey: 'country', value: 'country', translate: true},
                {name: 'statistic.Lang', key: 'language', sortKey: 'language', value: 'language', translate: true},
                {name: 'global.Geo', key: 'geo', sortKey: 'geo_name',  value: 'geo', translate: true},
                {name: 'global.Offer', key: 'offer_name', sortKey: 'offer_name', value: 'offer_name', translate: true},
                {name: 'global.Landing', key: 'landing_name', sortKey: 'landing_name', value: 'landing_name', translate: true},
                {name: 'global.Domain', key: 'domain', sortKey: 'domain', value: 'landing', translate: true},
                {name: 'global.Team', key: 'team', sortKey: 'team_name', value: 'team', translate: true},
                {name: 'global.Affiliate', key: 'affiliate_hash', sortKey: 'affiliate_name', value: 'affiliate', translate: true},
                {name: 'label.External_price', key: 'external_price', sortKey: 'external_price', value: 'external_price', translate: true, can: 'statistic_lead.show_lead_external_price'},
                {name: 'statistic_fields.sub1', key: 'sub1', sortKey: 'sub1', value: 'sub1', translate: true},
                {name: 'statistic_fields.sub2', key: 'sub2', sortKey: 'sub2', value: 'sub2', translate: true},
                {name: 'statistic_fields.sub3', key: 'sub3', sortKey: 'sub3', value: 'sub3', translate: true},
                {name: 'statistic_fields.sub4', key: 'sub4', sortKey: 'sub4', value: 'sub4', translate: true},
                {name: 'statistic_fields.sub5', key: 'sub5', sortKey: 'sub5', value: 'sub5', translate: true},
                {name: 'statistic_fields.sub6', key: 'sub6', sortKey: 'sub6', value: 'sub6', translate: true},
                {name: 'statistic_fields.sub7', key: 'sub7', sortKey: 'sub7', value: 'sub7', translate: true},
                {name: 'statistic_fields.sub8', key: 'sub8', sortKey: 'sub8', value: 'sub8', translate: true},
                {name: 'statistic_fields.sub9', key: 'sub9', sortKey: 'sub9', value: 'sub9', translate: true},
                {name: 'statistic_fields.sms', key: 'sms_status', value: 'sms', translate: true},
                {name: 'statistic.ADV_INT', key: 'advertiser_integration_id', sortKey: 'advertiser_name', value: 'advertiser', translate: true},
                {name: 'statistic.SYS_Status', key: 'status', value: 'status', translate: true},
                {name: 'statistic.ERR_Status', key: 'advertiser_response', sortKey: 'advertiser_response', value: 'errorStatus', translate: true},
                {name: 'statistic.Validation_errors', key: 'errors_validation', sortKey: 'errors_validation', value: 'eValidation', translate: true},
                {name: 'global.ADV_history', key: 'advertisers_history', sortKey: 'advertisers_history', value: 'a_history', translate: true},
                {name: 'statistic.ADV_Status', key: 'group_status', sortKey: 'group_status', value: 'group_status', translate: true},
                {name: 'statistic.Reg_date', key: 'created_at', sortKey: 'created_at', value: 'created_at', translate: true},
                {name: 'global.Send_date', key: 'send_date', sortKey: 'send_date', value: 'send_date', translate: true},
                {name: 'global.Action_date', key: 'first_action_date', sortKey: 'first_action_date', value: 'first_action_date', translate: true},
                {name: 'global.Actions', value: 'actions', translate: true}
            ],
            statusList: [
                'double',
                'hold',
                'not_valid',
                'sended',
                'sended_false',
                'test',
                'trash'
            ],
            csvFields: [
                'email',
                'country',
                'team_name',
                'group_status',
                'send_date',
                'first_action_date',
                'sub1',
                'sub2',
                'sub3',
                'sub4',
                'sub5',
                'sub6',
                'sub7',
                'sub8',
                'sub9',
                'advertiser_name',
                'advertisers_history',
                'integration_id',
                'integration_name'
            ]
        }
    },

    computed: {
        isTableSelect() {
            if ((this.selectStatus === 'hold' || this.selectStatus === 'not_valid') && this.activeGlobalToTrash) {
                return true
            } else if (this.selectStatus === 'sended' && this.activeGlobalStatuses) {
                return true
            } else {
                return false
            }
        },

        isAdv() {
            return this.userState.group === 2 ||
                this.userState.team.is_internal ||
                this.isPermission('statistic_lead.advertiser')
        },

        userState() {
            return this.$store.getters.userState
        }
    },

    watch: {
        '$i18n.locale'() {
            this.displays = this.createDisplayFields()

            if (this.filterOptions.guarantee && this.filterOptions.guarantee.length) {
                this.filterOptions.guarantee = this.guaranteeLocale(this.filterOptions.guarantee)
            }
        },

        direction(direction) {
            this.resetDate()

            this.selectedDate({
                ...this.date[direction],
                direction: direction
            })
        }
    },

    methods: {
        async toggleLeadSynchronization(id, isEnable) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: isEnable ? this.$t('modals.lead_synchronization_enable') : this.$t('modals.lead_synchronization_disable'),
                accept: async() => {
                    try {
                        await send(`/statistic/leads/${id}/synchronization-management`, 'PATCH')

                        await this.refreshTable()
                    } catch (e) {
                        new ErrorHandler(e).send
                    }
                },
                acceptText: this.$t('global.Save'),
                cancelText: this.$t('global.Cancel')
            })
        },

        createInputFilter(date, data) {
            const dateFilter = [
                {name: date.start + ' - ' + date.end, noTranslate: true},
                {name: `date.${date.direction}`}
            ]

            const filters = Object.entries(data).map(([key, value]) => {
                const field = this.fields.find(item => (item.reKey || item.field) === key)

                return {
                    name: field.name,
                    total: value.length
                }
            })

            this.inputs = [...dateFilter, ...filters]
        },

        filterClick() {
            if (this.$refs.filter) {
                this.$refs.filter.submitFilter()
            }
        },

        resetFilter() {
            if (this.$refs.filter) {
                this.$refs.filter.refreshFilter()
            }
        },

        async submitFilter(data) {
            this.filter = this.copyData(data)
            this.selectDate = this.selectDateSystem

            const transformValue = value => /^[-]$/.test(value) ? null : value

            Object.keys(this.filter).forEach(key => {
                this.filter[key] = Array.isArray(this.filter[key])
                    ? this.filter[key].map(transformValue)
                    : [transformValue(this.filter[key])]

                if (['ids', 'emails', 'phones'].includes(key)) {
                    this.filter[key] = this.filter[key].flatMap(item => item.trim().split(' ').filter(Boolean))
                }
            })

            this.get({
                page: 1
            })

            if (this.page !== 1) {
                this.page = 1
            }

            this.updateGroupStatusClose()

            this.closeSidebar()
        },

        async refreshFilter(get = true) {
            this.resetDate();
            this.selectedDate({
                ...this.date.send_date,
                direction: 'send_date'
            });

            this.selectDate = this.selectDateSystem
            this.filter = {}

            if (get) {
                await this.get({
                    page: 1
                })

                if (this.page !== 1) {
                    this.page = 1
                }

                this.updateGroupStatusClose()
            }
        },

        closeSidebar() {
            this.isFilter = false
        },

        selectedTable(ids) {
            if (this.selectStatus === 'not_valid' || this.selectStatus === 'hold') {
                this.leadTrashIds = ids
            } else if (this.selectStatus === 'sended') {
                this.statusIds = ids
            }
        },

        resetDate(direction) {
            Object.keys(this.date).map(key => {
                if (direction !== key) {
                    this.date[key].startDate = new Date()
                    this.date[key].endDate = new Date()
                }
            })
        },

        selectedDate(date) {
            this.resetDate('created_at')
            this.resetDate('send_date')
            this.resetDate('first_action_date')

            this.date[date.direction].startDate = date.startDate
            this.date[date.direction].endDate = date.endDate

            this.selectDateSystem = {
                direction: date.direction,
                start: this.dateParse(date.startDate),
                end: this.dateParse(date.endDate)
            }
        },

        async updateGroupStatus() {
            if (!this.statusIds.length) {
                this.activeGlobalStatuses = true
            } else {
                try {
                    EventBus.$emit('emitPopupEvent', {
                        type: 'updateLeadStatuses',
                        name: this.$t('tooltip.updateStatus'),
                        data: this.statusIds,
                        width: '300px'
                    })
                } catch (e) {
                    new ErrorHandler(e).send
                }
            }
        },

        updateGroupStatusClose() {
            this.$set(this, 'statusIds', [])
            if (this.$refs.table) {
                this.$refs.table.clearSelect()
            }
            this.activeGlobalStatuses = false
        },

        toTrashGlobalClose() {
            this.leadTrashIds = []
            this.$refs.table.clearSelect()
            this.activeGlobalToTrash = false
        },

        toTrashGlobal(ids) {
            if (!this.activeGlobalToTrash) {
                this.activeGlobalToTrash = true
            } else {
                this.toTrash(ids, true)
            }
        },

        async refreshTable() {
            await this.get()
        },

        async downloadCSV() {
            try {
                const columns = this.csvFieldNames()

                if (!columns.length) {
                    return
                }

                const params = {
                    ...this.selectDate,
                    limit: 500000,
                    page: this.page,
                    status: this.selectStatus,
                    order: this.order,
                    filters: this.filter,
                    columns
                }

                const response = await send(this.$url.statistic.exportcsv, 'GET', {
                    params,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    })
                })

                const fileName = `${params.start} - ${params.end}.csv`
                download(response.data, fileName, 'text/csv')
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        csvFieldNames() {
            return Object.values(this.displays)
                .reduce((acc, res) => {
                    if (res.value) {
                        if (res.key === 'person') {
                            acc.push('email')
                        } else if (res.key === 'advertiser_name') {
                            acc.push('integration_id', 'integration_name', 'advertiser_name')
                        } else {
                            acc.push(res.key)
                        }
                    }
                    return acc
                }, [])
                .filter(item => this.csvFields.includes(item))
        },

        toTrash(ids, action) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: this.$t('modals.Send_to_trash'),
                accept: async () => {
                    try {
                        await send('/statistic/trash', 'PUT', {params: {id: ids}})

                        await this.get({
                            page: 1
                        })

                        this.page = 1

                        this.leadTrashIds = []
                        this.$refs.table.clearSelect()

                        if (action) {
                            this.activeGlobalToTrash = false
                        }
                    } catch (e) {
                        new ErrorHandler(e).send
                    }
                },
                acceptText: this.$t('statistic_fields.send'),
                cancelText: this.$t('global.Cancel')
            })
        },

        infoByIntegration(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'leadInfoIntegration',
                name: this.$t('modals.Lead_info_integration'),
                ids: data.id,
                full: true
            })
        },

        async edit(data) {
            EventBus.$emit('emitPopupEvent', {type: 'editLead', name: this.$t('modals.Edit_lead'), ids: data.id})
        },

        async comments(data) {
            try {
                const params = {
                    id: data.id
                }

                const comments = await send(`${this.$url.statistic.get_lead_comments}`, 'GET', {params})
                    .then(data => data.data.result.comment)

                EventBus.$emit('emitPopupEvent', {
                    type: 'commentLead',
                    name: this.$t('modals.Lead_comments'),
                    ids: {content: comments ? comments : [], email: data.email}
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getHistoryStatuses(data) {
            try {
                const params = {
                    id: data.id
                }

                const leadHistoryStatuses = await send(this.$url.statistic.get_lead_history_statuses, 'GET', {params})
                    .then(data => data.data.result.lead_history_statuses)

                EventBus.$emit('emitPopupEvent', {
                    type: 'leadHistoryStatuses',
                    name: this.$t('modals.Lead_history_statuses'),
                    ids: leadHistoryStatuses
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        getGeoFlag(geo) {
            return getLanguages(geo)
        },

        statusColor(status) {
            const template = {
                hold: '#FF9F43',
                sended: '#28C76F',
                not_valid: '#CCCCCC',
                trash: '#EA5455',
                duplicate: '#CCCCCC'
            }

            return template[status] || '#CCCCCC'
        },

        createName(name) {
            if (!name) return '-'

            const formattedName = name.replace(/_/g, ' ').toLowerCase()
            return formattedName.charAt(0).toUpperCase() + formattedName.slice(1)
        },

        copy(data) {
            if (data) {
                copy(data)

                const icon = this.$iconData('icon-check', 'fi-rr-check')
                this.$vs.notify({
                    time: 18000,
                    title: 'Success!',
                    text: this.$t('notification.success'),
                    color: 'success',
                    iconPack: icon['icon-pack'],
                    icon: icon.icon
                })
            }
        },

        errorStatusInfo(data) {
            EventBus.$emit('emitPopupEvent', {type: 'errorStatusInfo', name: this.$t('statistic.ERR_Status'), data: data})
        },

        copyData(data) {
            return JSON.parse(JSON.stringify(data))
        },

        async changeView(key, value) {
            this.displays[key].value = !value

            const display = Object.keys(this.displays).reduce((res, key) => {
                res[key] = this.displays[key].value
                return res
            }, {})

            await send(this.$url.user['change-fields'], 'PUT', {
                data: {fields: JSON.stringify(display)}
            })

            this.$store.commit('SET_USER_FIELDS', {
                event: value,
                display: key
            })
        },

        async changeTab(status) {
            if (status !== this.selectStatus) {
                await this.get({
                    status,
                    page: 1
                })

                this.page = 1
                this.selectStatus = status
            }
        },

        async changePage(page) {
            if (this.page !== page) {
                await this.get({page})

                this.page = page
            }
        },

        async changeOrder(order) {
            const _order = order.direction ? order : {...order, direction: 'desc'}

            await this.get({order: _order})

            this.order = _order
        },

        async changeLimit(limit) {
            if (limit !== this.limit) {
                await this.get({
                    limit,
                    page: 1
                })

                this.limit = +limit
                this.page = 1
            }
        },

        createDisplayFields() {
            this.displays = this.headers.reduce((res, data) => {
                res[data.value] = {
                    name: data.name,
                    value: true,
                    key: data.sortKey || data.key
                }

                return res
            }, {})

            return this.displays
        },

        guaranteeLocale() {
            return [
                {name: this.$t('global.no_guarantee'), id: '0'},
                {name: this.$t('global.guarantee'), id: '1'}
            ]
        },

        createCount(count) {
            return [
                'sended',
                'hold',
                'not_valid',
                'trash',
                'double'
            ].map(name => ({
                name: `leadCount.${name}`,
                count: count[name],
                event: name
            }))
        },

        async getLeads(params = {}) {
            try {
                return await send(this.$url.statistic.get, 'GET', {
                    params,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    }),
                }).then(response => response.data.result)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getCount(params = {}) {
            try {
                const obj = {...params}

                delete obj.limit
                delete obj.page
                delete obj.order

                return await send(this.$url.statistic['lead-count'], 'GET', {
                    params: obj,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    }),
                }).then(response => response.data.result.counts)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        parseJSON(data) {
            try {
                return JSON.parse(data)
            } catch (e) {
                return data
            }
        },

        replaceNullToString(data) {
            Object.entries(data).map(([key, value]) => {
                data[key] = value.map(item => item === null ? '-' : item)
            })

            return data
        },

        showByStatus(status) {
            const headers = this.copyData(this.headerSystems)

            const templateHide = {
                sended: ['eValidation'],
                trash: ['eValidation', 'external_price'],
                duplicate: ['actions', 'eValidation', 'guarantee', 'external_price'],
                hold: ['guarantee', 'external_price'],
                not_valid: ['guarantee', 'external_price']
            }

            return headers.filter(header => !templateHide[status].includes(header.value) && (!header.can || this.isPermission(header.can)))
        },

        async get(options = {}) {
            try {
                this.isLoader = true

                const params = {
                    ...this.selectDate,
                    status: this.selectStatus,
                    limit: this.limit,
                    page: this.page,
                    order: this.order,
                    filters: {...this.filter},
                    ...options
                }

                const [leads, count] = await Promise.all([
                    this.getLeads(params),
                    this.getCount(params)
                ])

                this.toHistory(params)

                this.createInputFilter(this.selectDate, this.filter)

                leads.filters = {
                    ...leads.filters,
                    ...leads.filters.additional
                }

                if (!leads.filters.additional.manager_ids) {
                    this.fields = this.fields.filter(item => item.field !== 'manager_ids')
                }
                delete leads.filters.additional

                leads.filters = this.replaceNullToString(leads.filters)
                leads.filters.affiliates = leads.filters.affiliates.map(item => ({
                    ...item,
                    name: `${item.team_name || item.team_id} / ${item.name}`
                }))

                leads.filters.integrations = leads.filters.integrations.map(item => ({
                    ...item,
                    name: `${item.advertiser_name || item.advertiser_id} / ${item.name}`
                }))

                leads.filters.guarantee = leads.leads.length ? this.guaranteeLocale() : []

                this.filterOptions = leads.filters

                this.counts = this.createCount(count)

                this.headers = this.showByStatus(params.status)

                this.data = leads.leads
                this.total = count[params.status]

                this.displays = this.createDisplayFields()

                if (this.userState.lead_statistic_fields) {
                    const display = this.parseJSON(this.userState.lead_statistic_fields)

                    Object.keys(display).forEach(key => {
                        if (this.displays[key]) {
                            this.displays[key].value = display[key]
                        }
                    })
                }
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.isLoader = false
            }
        },

        async historyData() {
            const history = this.getHistory()

            if (
                !/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(history.start) ||
                !/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(history.end) ||
                !Object.keys(this.date).includes(history.direction)
            ) {
                await this.toHistory({
                    start: this.dateParse(new Date),
                    end: this.dateParse(new Date),
                    direction: 'send_date'
                })

                this.direction = 'send_date'
            } else {
                this.selectDateSystem = {
                    start: history.start,
                    end: history.end,
                    direction: history.direction
                }

                this.selectDate = {
                    start: history.start,
                    end: history.end,
                    direction: history.direction
                }

                this.date[history.direction] = {
                    startDate: new Date(history.start),
                    endDate: new Date(history.end)
                }

                this.direction = history.direction
            }

            if (history.filters) {
                this.filter = this.convertStringNumbers(history.filters)
            }

            this.page = Math.abs(+history.page) || 1
            if (!+history.page || /^[-].*/.test(history.page)) {
                await this.toHistory({ page: this.page })
            }

            if (!this.limits.includes(+history.limit)) {
                await this.toHistory({ limit: this.limits[0] })
                this.limit = this.limits[0]
            } else {
                this.limit = +history.limit
            }

            this.selectStatus = this.statusList.some(item => item === history.status) ? history.status : 'sended'
            if (this.selectStatus !== history.status) {
                await this.toHistory({ status: 'sended' })
            }

            this.order = history.order || {name: 'id', direction: 'desc'}
            if (!history.order) {
                await this.toHistory({ order: {name: 'id', direction: 'desc'} })
            }
        }
    },

    async mounted() {
        await this.historyData()

        await this.get()

        if (!this.isAdv) {
            const template = [
                'advertisers',
                'integrations'
            ]

            this.headers = this.headerSystems.filter(header => !template.includes(header.value))
        }

        if (!(this.userState.team.is_internal || this.userState.group === 2)) {
            this.headers = this.headerSystems.filter(item => item.value !== 'a_history')
        }

        if (this.userState.group !== 2) {
            this.headers = this.headerSystems.filter(item => item.value !== 'ftd_status')
        }

        window.onpopstate = async (event) => {
            await this.historyData()

            await this.get()
        }

        if (!this.isPermission('settings_team.show_team_name')) {
            const index = this.fields.findIndex(item => item.field === 'teams')
            this.$set(this.fields[index], 'sоrtKey', 'id')
        }

        if (!this.isPermission('settings_advertiser.show_advertiser_name')) {
            const index = this.fields.findIndex(item => item.field === 'advertisers')
            this.$set(this.fields[index], 'sоrtKey', 'id')
        }

        this.isMounted = true

        this.$nextTick(() => {
            if (this.$refs.actions) {
                this.inputOffset = this.$refs.actions.clientWidth
            }
        })

        EventBus.$on('updateLeads', async (lead) => {
            await this.refreshTable()
        })

        EventBus.$on('reloadTable', async () => {
            await this.get()
        })

        EventBus.$on('doneStatusMapping', async () => {
            this.updateGroupStatusClose()
            await this.refreshTable()
        })
    },

    destroyed() {
        EventBus.$off('updateLeads')
        EventBus.$off('doneStatusMapping')
        EventBus.$off('reloadTable')
    }
}
</script>

<style lang="scss">
.leads-nexus {
    &-sidebar {
        &__container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        &__actions {
            display: flex;
        }
    }

    .statusErrorsText {
        max-width: 250px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}

.mx-datepicker-popup {
    z-index: 999999 !important;
}
</style>
